export default {
  // 教学成效学习进度
  StuLearningProgress:'',
  stuActivityTake:'',//活动参与率
  stuActivitytime:'',//活跃组织次数
  stuAttendance:'',//考勤预警
  stuPrepareWarning:'',//预习预警
  stuJobWarning:'',//作业预警
  stuActivityWarning:'',//活动预警
  stuEvaluate:'',//过程性评价
  stuTeachDetail:'',//教学明细表
  stuHeadrInformation:'',//学生头部信息
  stuTestCondition:'',//测验情况
  stuEvaluateCondition:'',//过程性评价
  stuJobCondition:'',//作业情况
  stuInfo:'',//学生信息
  stuSignCondition:'',//学生考勤情况
  stuPrepareCondition:'',//学生预习情况
  StuLearningProgressWarning:'',//学生学习进度预警
}
